import exceljs from "exceljs";
import {saveAs} from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    MyDate, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filteredApprovals, 
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    return (
        <button
            type = "button"
            className = "headerButton" 
            onClick = {() => {
                setShowLoader(true);
                const workbook = new exceljs.Workbook();
                workbook.creator = user.userName;
                workbook.created = new Date();
                workbook.calcProperties.fullCalcOnLoad = true;
                const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
                worksheet.state = "visible";
                worksheet.properties.defaultColWidth = 22.57;
                const rows = filteredApprovals.map(approval => [
                    approval.projectName,
                    approval.category, 
                    approval.laborCategory, 
                    approval.laborName, 
                    approval.department, 
                    approval.workLogSubmitTimeExcel, 
                    approval.plannedTimeExcel
                ]);
                worksheet.addTable({
                    name: "MyTable",
                    ref: "A1",
                    totalsRow: true,
                    style: {
                        showRowStripes: true,
                    },
                    columns: [
                        { name: "Project Name", filterButton: true},
                        { name: "Project Category", filterButton: true},
                        { name: "Labor Category", filterButton: true},
                        { name: "Labor Name", filterButton: true},
                        { name: "Department", filterButton: true},
                        { name: "Submit Time", filterButton: true},
                        { name: "Planned Time", filterButton: true},
                    ],
                    rows: rows,
                });
                worksheet.columns.forEach(column => {
                    const minLength = 18;
                    let maxLength = 0;
                    column["eachCell"]({ includeEmpty: true }, cell => {
                        // exclude row 1 ----------
                        if(cell.row === 1) return;
                        //-------------------------
                        const columnLength = cell.value?
                        cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                        :minLength;
                        if(columnLength > maxLength){
                            maxLength = columnLength;
                        }
                    });
                    column.width = maxLength < minLength ? minLength : maxLength;
                });
                worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
                workbook.xlsx.writeBuffer().then(buffer => {
                    saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `Approvals export ${(new MyDate()).s()}.xlsx`);
                    setShowLoader(false);
                })
            }}
        >
            Export
        </button>
    )
}